export function interopRequireDefault<T>(defaultImport: T): T {
  const asAny: any = defaultImport
  // istanbul ignore next
  return asAny.__esModule ? asAny.default : defaultImport
}
